import { Network } from '@interfaces/network.model';

export type NetworkState = Network;

export const initialState: NetworkState = new Network({});
